var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconClose = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 10,
  height: 10,
  viewBox: "0 0 10 10",
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.73688 8.46644L6.27043 4.99999L9.73688 1.53354C10.0877 1.1827 10.0877 0.61393 9.73688 0.263152C9.3861 -0.0877476 8.81727 -0.0876868 8.46649 0.263152L4.99998 3.7296L1.53353 0.263152C1.18269 -0.0876868 0.613922 -0.0876868 0.263083 0.263152C-0.0876944 0.61393 -0.0876944 1.1827 0.263083 1.53354L3.72954 4.99999L0.263083 8.46644C-0.0876944 8.81728 -0.0876944 9.38605 0.263083 9.73689C0.613922 10.0877 1.18269 10.0877 1.53359 9.73689L5.00004 6.27043L8.46649 9.73689C8.81727 10.0877 9.3861 10.0877 9.73688 9.73689C10.0877 9.38611 10.0877 8.81728 9.73688 8.46644Z",
  fill: "white"
})));
export default __webpack_public_path__ + "static/media/icon_close.6467e8d3.svg";
export { SvgIconClose as ReactComponent };